angular
  .module 'shared'
  .factory 'MasqueradingService', ->
    isMasquerading: ->
      window.masquerading
